<template>
  <div class="image-box" @mouseenter="showOverlay = true" @mouseleave="showOverlay = false">
    <div class="overlay-body">
      <img :src="vModelImg" v-if="vModelImg" />
      <slot name="overlay-body">
        <div class="overlay-option">
          <i class="ri-fullscreen-line icon" v-if="vModelImg" @click="emits('overlayFn', 'fullScreen')"></i>
          <i class="ri-refresh-line icon" v-if="vModelImg" @click="emits('overlayFn', 'refresh')"></i>
          <i class="ri-add-box-fill icon" v-if="!vModelImg" @click="emits('overlayFn', 'add')"></i>
          <i class="ri-delete-bin-fill icon" v-if="vModelImg" @click="emits('overlayFn', 'delete')"></i>
        </div>
      </slot>
    </div>
  </div>
</template>

<script setup>
import { ref, defineEmits, defineProps, computed } from 'vue';
let emits = defineEmits(['overlayFn', 'update:img']);
let props = defineProps({
  img: {
    type: String,
    default: ''
  }
})
let vModelImg = computed({
  get() {
    return props.img;
  },
  set(value) {
    emits('update:img', value);
  },
})
const showOverlay = ref(false);

</script>

<style lang="scss" scoped>
.image-box {
  width: 150px;
  height: 100px;
  border: 2px solid #555555;
  background-color: #f2f4f7;
  border-radius: 5px;
  padding: 5px;
  box-sizing: border-box;
  position: relative;

  &:hover {
    border-color: #5754f9;
  }

  .overlay-body {
    width: 100%;
    height: 100%;
    position: relative;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .overlay-option {
      position: absolute;
      bottom: 0;
      width: 100%;
      height: 25px;
      background-color: rgba(54, 62, 77, 0.8);
      color: white;
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 10px;
      font-size: 16px;
      cursor: pointer;

      .icon {
        cursor: pointer;

        &:hover {
          font-weight: bold;
          color: #5754f9;


        }
      }
    }
  }
}
</style>
